(function () {
  function initFaq(root) {
    root = root || document;

    // Accordion
    root.querySelectorAll(".ac-card .ac-item .ac-q").forEach(function (btn) {
      if (btn.dataset.acBound === "1") return;
      btn.dataset.acBound = "1";

      btn.addEventListener("click", function () {
        var item = btn.closest(".ac-item");
        var card = btn.closest(".ac-card");
        if (!item || !card) return;

        card.querySelectorAll(".ac-item.is-open").forEach(function (openItem) {
          if (openItem !== item) openItem.classList.remove("is-open");
        });

        item.classList.toggle("is-open");
      });
    });

    // Modal
    var modal = document.getElementById("ac-modal");
    var openBtn = document.getElementById("open-contact-modal");
    var closeBtn = document.getElementById("close-contact-modal");
    var ok = document.getElementById("ac-ok");
    var err = document.getElementById("ac-err");
    var form = document.getElementById("ac-form");

    function openModal() {
      if (!modal) return;
      modal.style.display = "flex";
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }
    function closeModal() {
      if (!modal) return;
      modal.style.display = "none";
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      if (ok) ok.style.display = "none";
      if (err) err.style.display = "none";
    }

    if (openBtn && openBtn.dataset.acBound !== "1") {
      openBtn.dataset.acBound = "1";
      openBtn.addEventListener("click", openModal);
    }
    if (closeBtn && closeBtn.dataset.acBound !== "1") {
      closeBtn.dataset.acBound = "1";
      closeBtn.addEventListener("click", closeModal);
    }

    if (modal && modal.dataset.acBound !== "1") {
      modal.dataset.acBound = "1";
      modal.addEventListener("click", function (e) {
        if (e.target === modal) closeModal();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && modal.style.display === "flex") closeModal();
      });
    }

    if (form && form.dataset.acBound !== "1") {
      form.dataset.acBound = "1";
      form.addEventListener("submit", function (e) {
        e.preventDefault();

        var name = (document.getElementById("ac-name")?.value || "").trim();
        var email = (document.getElementById("ac-email")?.value || "").trim();
        var msg = (document.getElementById("ac-msg")?.value || "").trim();

        if (ok) ok.style.display = "none";
        if (err) err.style.display = "none";

        if (!name || !email || !msg) {
          if (err) err.style.display = "block";
          return;
        }

        if (ok) ok.style.display = "block";

        var subject = encodeURIComponent("Resale request - " + name);
        var body = encodeURIComponent("Name: " + name + "\nEmail: " + email + "\n\n" + msg);

        window.location.href =
          "mailto:support@accesconcert.fr?subject=" + subject + "&body=" + body;
      });
    }
  }

  // Normal page load
  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".ac-faq")) initFaq(document);
  });

  // Shopify theme editor / dynamic section reload
  document.addEventListener("shopify:section:load", function () {
    if (document.querySelector(".ac-faq")) initFaq(document);
  });

  // If the theme swaps content with ajax
  window.addEventListener("load", function () {
    if (document.querySelector(".ac-faq")) initFaq(document);
  });
})();
